import { initI18n } from 'www/utils'

async function addDoctorPageLpuListBundle() {
  await initI18n({ bundle: 'vue_components/common/DoctorPageLpuList' })
}

addDoctorPageLpuListBundle()
